import { Expose, Transform } from "class-transformer";
import {
  PointConfigurationApplicationModeEnum,
  PointConfigurationFunctionalityEnum,
  PointConfigurationPaymentMethodEnum,
} from "@altertec_gparn/lib";
import { toCents } from "@/utils/numberUtils";

function toOptionalCents(value: number | null | undefined): number | null {
  if (value == null) return null;
  return toCents(Number(value));
}

export class UpdatePointConfigurationDto {
  @Expose()
  operativeUnitId?: string | null;

  @Expose()
  functionality?: PointConfigurationFunctionalityEnum;

  @Expose()
  paymentMethod?: PointConfigurationPaymentMethodEnum;

  @Expose()
  appliesToProjectOperativeUnit?: boolean;

  @Expose()
  isTravelTimePaidAsOrdinary?: boolean;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  fixedPriceFirstPoint?: number | null;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  fixedPriceSecondPoint?: number | null;

  @Expose()
  applicationMode?: PointConfigurationApplicationModeEnum;

  @Expose()
  payrollConceptKey?: string | null;
}
